import request from "../util/SuperagentUtils";
import { spaceRequestEndpoints } from "./api-endpoints";

interface SpaceRequest {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  numberOfSpaces: string;
  city: string;
  state: string;
  startDate: string;
  duration: string;
  equipmentTypes: string[];
}

export const requestLocationSpace = (spaceRequest: SpaceRequest) => {
  return request.post(spaceRequestEndpoints.submit).send(spaceRequest)
}